import React, {useState} from 'react'
// import {navigate} from 'gatsby'
import tw, { styled } from 'twin.macro'
// import styled from 'styled-components'
import Link from 'next/link'
import { Button } from '@chakra-ui/react'
// import {up} from 'styled-breakpoints'
import {Block} from 'baseui/block'
import {TextGR16} from 'components/Typography'
import {AlertModal} from 'components/AlertModal'
// import {usePolkadotAccountAtom} from 'atoms'

import DiscordIcon from '../../svgs/discord.svg'
import TwitterIcon from '../../svgs/twitter.svg'
import LogoPhala from './logo-phala.svg'
import LogoPhalaWorld from './logo-phalaworld.svg'

import {ProjectList, RouteList1, RouteList2} from './listData'
import EmailInput from './EmailInput'

const Grid = tw.footer`grid grid-cols-12 gap-5 w-full font-primary pt-10 mt-10`

const Aside = tw.aside`col-start-2 col-span-10 md:col-span-2 md:col-start-2 h-full`

const StyledLogoPhalaWorld = tw(LogoPhalaWorld)`w-full md:w-[16.14583333vw] mb-4 md:mb-[1.875vw] max-w-[310px] text-white`

const StyledLogoPhala = styled(LogoPhala)`
  ${tw`w-full md:w-[9.0625vw] mb-8 md:mb-[4.11458333vw] max-w-[174px]`}
  color: rgba(255, 255, 255, 0.2);
`
const ProjectSection = tw.div`col-start-2 col-span-11 md:col-span-1 md:col-start-4 xl:col-start-5 3xl:col-start-7 mb-6 md:mb-0`

const NavSection = tw.div`col-start-2 col-span-11 md:col-span-2 md:col-start-6 3xl:col-start-8 md:px-10 mb-6 md:mb-0`

const SocialSection = tw.div`col-start-2 col-span-12 md:col-span-3 md:col-start-9 flex md:justify-end 2xl:col-start-10 2xl:col-span-2 mb-6 md:mb-0`

const SocialSectionContainer = tw.div`flex flex-col`

const IconGroup = tw.div`flex flex-row mt-4`

const SectionHeading = tw.h4`text-white text-lg font-bold mb-8`

const TextLine = tw.div`col-start-2 col-span-11 md:col-start-2 md:col-span-10 flex flex-col justify-end items-end md:flex-row md:justify-between uppercase text-xs`

const SloganSection = tw.div`text-xs text-[#8c8c8c] mb-2`

const CopyrightSection = tw.div`text-right text-[#d9d9d9] mb-2`

const RouterBox = styled(Block)`
  display: flex;
  flex-direction: row;
  gap: 30px;
  ${tw`xl:gap-24`}
`
  // ${up('xl')} {
  //   gap: 100px;
  // }

const ListItem = styled(TextGR16)`
  color: #8c8c8c;
  margin-bottom: 18px;
  transition: 0.5s ease;
  cursor: pointer;

  :hover {
    color: #36fad7;
  }
`

const MediaIcon = styled.a`
  margin-right: 30px;

  svg {
    path {
      fill: #8c8c8c;
    }
  }

  &:hover {
    svg {
      path {
        fill: #36fad7;
      }
    }
  }
`

const Footer: React.FC = () => {
  // const [polkadotAccount] = usePolkadotAccountAtom()
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  // const handleRoute = (route: string) => {
  //   if (/^\/(claim|user|lobby)/.test(route) && !polkadotAccount) {
  //     setIsOpenAlertModal(true)
  //     return
  //   }

  //   if (route === '/') {
  //     window.location.replace('/')
  //     return
  //   }
  //   if (/^\/(user)/.test(route) && polkadotAccount) {
  //     navigate(`/user/${polkadotAccount.address}`)
  //   }
  //   navigate(route)
  // }
  return <>
    <Grid>
      <Aside>
        <StyledLogoPhalaWorld />
        <StyledLogoPhala />
      </Aside>
      <ProjectSection>
        <SectionHeading>Project</SectionHeading>
        {ProjectList.map((item) => (
          <a
            key={item.name}
            href={item.href}
            title={item.name}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItem>{item.name}</ListItem>
          </a>
        ))}
      </ProjectSection>
      <NavSection>
        <SectionHeading>Home</SectionHeading>
        <RouterBox>
          <div>
            {RouteList1.map((item) => (
              <Link key={item.name} href={item.href} passHref legacyBehavior>
                <Button as="a" variant="link" color="#8c8c8c">
                  {item.name}
                </Button>
              </Link>
              // <ListItem
              //   key={item.name}
              //   onClick={() => handleRoute(item.href)}
              // >
              //   {item.name}
              // </ListItem>
            ))}
          </div>
          <div>
            {RouteList2.map((item) => (
              <Link as={ListItem} key={item.name} href={item.href} legacyBehavior>
                {item.name}
              </Link>
              // <ListItem
              //   key={item.name}
              //   onClick={() => handleRoute(item.href)}
              // >
              //   {item.name}
              // </ListItem>
            ))}
          </div>
        </RouterBox>
      </NavSection>
      <SocialSection>
        <SocialSectionContainer>
          <SectionHeading>Subscribe</SectionHeading>
          <EmailInput />
          <IconGroup>
            <MediaIcon
              href="https://twitter.com/PhalaWorld"
              title="Twitter"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon width="33px" height="24px" />
            </MediaIcon>
            <MediaIcon
              href="http://discord.gg/phalaworld"
              title="Discord"
              target="_blank"
              rel="noopener noreferrer"
            >
              <DiscordIcon width="33px" height="24px" />
            </MediaIcon>
          </IconGroup>
        </SocialSectionContainer>
      </SocialSection>
      <TextLine>
        <SloganSection>COME AND SAVE THE WORLD</SloganSection>
        <CopyrightSection>
          COPYRIGHT © 2022 PHALA.LTD ALL RIGHTS RESERVED.
        </CopyrightSection>
      </TextLine>
    </Grid>
    <AlertModal
      content="Connect with Khala wallet or create a new one."
      visible={isOpenAlertModal}
      onClose={() => setIsOpenAlertModal(false)}
    />
  </>;
}

export default Footer
